import React, { FunctionComponent, useState } from 'react';

import styles from './YouTubeVideoCard.module.scss';
import PostCardTopBar from '../PostCardTopBar';
import PostCardTextContent from '../PostCardTextContent';
import DateLocation from '../DateLocation';
import UserInformation from '../UserInformation';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DefaultVideo from '../../assets/images/defaultVideo.png';
import { _t } from 'app/utils/i18n';
import { path } from 'app/utils/path';
import { checkTranslated, handelUrlID } from 'app/utils/helpers';
import { useModal } from 'app/context/Modal';
import { nFormatter } from 'app/utils/numbersFormater';
import { Accordion, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getFromLocalStorage } from 'app/utils/localStorage';
import {
  useHandleNavigateInfluencerOrEntity,
  useOpenModalToAddUserAsInfluencer,
} from 'app/utils/check-influencer-user';
import { storeInfluencerYoutuber } from 'influencers/Requests';
import { BluePlayArrowIcon } from 'app/assets/images/icons';

interface Props {
  data: any;
  compId?: string;
  isReport?: boolean;
  isContentClickable?: boolean;
  isComment?: boolean;
  post_type?: 'negative' | 'positive' | 'neutral' | 'all';
  showPosts?: boolean;
  withBigSize?: boolean;
  isTemplate?: boolean;
}

const YouTubeVideoCard: FunctionComponent<Props> = ({
  data,
  compId,
  isReport,
  isContentClickable,
  post_type,
  isComment,
  showPosts,
  withBigSize,
  isTemplate,
}) => {
  const modal = useModal();
  const handelOpenVideo = () => {
    modal.show({
      videoUrl: `https://www.youtube.com/embed/${handelUrlID(data?.url)}`,
    });
  };
  const pathname = location?.pathname?.split('/')?.[1];
  const [isTranslated, setIsTranslated] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const newLineFormatter = (text: string) => {
    return text?.replace(/\\n/gi, '\n').replace(/\n/gi, '\n');
  };
  const isEn = getFromLocalStorage('LNG') === 'en';
  const [handleNavigateInfluencerOrEntity] =
    useHandleNavigateInfluencerOrEntity();
  const [openModalToAddUserAsInfluencer] = useOpenModalToAddUserAsInfluencer(
    storeInfluencerYoutuber,
  );
  const translationToggle = () => {
    if (isTranslated === true) {
      setIsTranslated(false);
    } else {
      setIsTranslated(true);
    }
  };
  return (
    <div
      id={`${compId}-YouTubeVideoCard-${data?.id}`}
      className={styles.YouTubeVideoCard}
    >
      <div className={styles.YouTubeVideoCard_Container}>
        {!isReport && (
          <PostCardTopBar
            platformUrl={data?.url || data?.post_url}
            platform={
              data?.platform ? data?.platform : data?.influencer?.platform
            }
            postId={data?.id}
            compId={`${compId}-YouTubeVideoCard-${data?.id}`}
            postLanguages={data?.languages}
            content={data?.title || data?.text?.original}
            contentTranslated={data?.title_translated || data?.text?.arabic}
            translationToggle={translationToggle}
          />
        )}
        <div
          className={`${styles.YouTubeVideoCard_Container_content} post_card_url`}
          data-type={data?.url}
          style={{ padding: withBigSize ? '10px 20px 0' : undefined }}
        >
          <UserInformation
            profileImage={
              data?.channel_thumbnail ||
              data?.influencer?.image_url ||
              data?.profile_image_url
            }
            // username=""
            name={isComment ? data?.username : data?.channel_name}
            postType={post_type}
            isSmallerSize={
              pathname === 'influencers' || pathname === 'entities'
            }
            isVerified={data?.is_verified}
            handleInfluencerOrEntity={() =>
              handleNavigateInfluencerOrEntity(data?.influencer)
            }
            isClickable={!isTemplate}
            isUserAdded={data?.influencer?.influencer_id !== 0}
            openModalToAddInfluencer={() =>
              openModalToAddUserAsInfluencer(
                data?.channel?.remote_id,
                data?.influencer?.url || data?.channel?.url,
                _t('hashtags:open_in_youtube'),
                true,
              )
            }
            hideAtIcon
            withSubscriberCount={!isComment}
            subscriberCount={data?.channel?.subscriber_count}
          />
          <PostCardTextContent
            content={isComment ? data?.text : data?.title}
            isReport={isReport}
            isTranslated={isTranslated}
            detailsUrl={`${path.posts.YOUTUBE_POST_DETAILS_URI}/${data?.id}`}
            isContentClickable={isContentClickable}
            content_translated={data?.title_translated}
          />
          {!isComment && (
            <div
              onClick={() => handelOpenVideo()}
              className={`${styles.youtube_thumbnail}`}
            >
              <img
                src={!data?.thumbnail ? DefaultVideo : data?.thumbnail}
                alt="image"
              />
              <button className={styles.VideoBtn}>
                <BluePlayArrowIcon />
              </button>
            </div>
          )}

          <div style={{ margin: '10px 0px' }}>
            <DateLocation created_at={data?.published_at} />
          </div>
          {showPosts && !!data?.post?.length && (
            <div className={styles.VideoPost}>
              <pre
                data-testid="post-videoDetails"
                className={`${styles.videoPost_Text} ${
                  !showMoreDetails && styles.showLessDetails
                }`}
              >
                {newLineFormatter(
                  checkTranslated(data?.post, data?.post_translated),
                )}
              </pre>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon fontSize="small" />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ padding: 0 }}
                  data-testid="setShowMoreDetails"
                  onClick={() => setShowMoreDetails(!showMoreDetails)}
                >
                  <p className={styles.showMoreDetailsToggle}>
                    {showMoreDetails
                      ? _t('basic:see_less')
                      : _t('basic:see_more')}
                  </p>
                </AccordionSummary>
              </Accordion>
            </div>
          )}
          <div
            className={styles.youtubePostCardStatus}
            style={{ padding: withBigSize ? '20px 0 ' : '10px 0' }}
          >
            {!isComment && (
              <div>
                <span>{_t('trends:comments')}</span>
                <span>{nFormatter(data?.comments_count)}</span>
              </div>
            )}
            <div>
              <span>{_t('trends:likes')}</span>
              <span>{nFormatter(data?.likes_count)}</span>
            </div>
            {!isComment && (
              <div>
                <span>{_t('basic:views')}</span>
                <span>{nFormatter(data?.views_count)}</span>
              </div>
            )}
            {isComment && (
              <div>
                <span>{_t('hashtags:replies')}</span>
                <span>{nFormatter(data?.replies_count)}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeVideoCard;
